import React from "react";
import PageHeader, { LegalBody } from "../components/PageHeader";
import { COMPANY } from "../mock/data";

export default function Shipping() {
  return (
    <>
      <PageHeader eyebrow="Legal" title="Shipping & Delivery Policy" subtitle={`How ${COMPANY.brand} digital products are delivered after purchase.`} />
      <LegalBody>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <h2>1. Digital Product Delivery</h2>
        <p>{COMPANY.brand} is a digital software product. There is no physical shipment. After a successful purchase, your license and activation instructions are delivered by email to the address provided at checkout.</p>

        <h2>2. Delivery Timeline</h2>
        <ul>
          <li>Order confirmation email is sent immediately upon successful payment.</li>
          <li>License activation details are typically delivered within 5–15 minutes.</li>
          <li>In rare cases (payment verification or high volume), delivery may take up to 24 hours.</li>
        </ul>

        <h2>3. Not Received Your Email?</h2>
        <ul>
          <li>Check your Spam / Promotions folder.</li>
          <li>Confirm the email address entered at checkout is correct.</li>
          <li>Contact support at <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> or call <a href={`tel:${COMPANY.phoneRaw}`}>{COMPANY.phone}</a>.</li>
        </ul>

        <h2>4. Installation Support</h2>
        <p>Our support team can walk you through installation, activation, and initial setup on any supported Android device — available 24/7.</p>

        <h2>5. International Availability</h2>
        <p>{COMPANY.brand} is available for download worldwide. Local payment methods, currency, and tax rates depend on your region and are shown at checkout.</p>

        <h2>6. Contact</h2>
        <p>
          {COMPANY.legalName}<br />
          Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a><br />
          Phone: <a href={`tel:${COMPANY.phoneRaw}`}>{COMPANY.phone}</a>
        </p>
      </LegalBody>
    </>
  );
}
